"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IkeRestQuery = exports.MAX_API_RESULTS = void 0;
const tslib_1 = require("tslib");
const core_api_1 = require("@ikegps/core-api");
exports.MAX_API_RESULTS = 5000;
function getGTLTValue(value) {
    if (typeof value !== 'string') {
        return value;
    }
    if (value.length !== 24) {
        return value;
    }
    const date = new Date(value);
    if (isNaN(date.getTime())) {
        return value;
    }
    return date;
}
class IkeRestQuery {
    constructor(core, ike, sessionToken, departmentId, log) {
        this.limitResults = 200;
        this.skippedResults = 0;
        this.where = {};
        this.sortField = null;
        this.core = core;
        this.log = log;
        this.ike = ike;
        this.sessionToken = sessionToken;
        this.departmentId = departmentId;
    }
    /**
     * Sort the query based off the fieldName;
     *
     * @param fieldName Sort field name
     * @param direction 1 = ascending, -1 = descending
     */
    sort(fieldName, direction = core_api_1.IkeQuerySort.ASC) {
        if (this.sortField == null) {
            this.sortField = {};
        }
        this.sortField[fieldName] = direction;
        return this;
    }
    equal(key, value) {
        this.where[key] = value;
        return this;
    }
    in(key, value) {
        this.where[key] = { $in: value };
        return this;
    }
    gt(key, value) {
        const $gt = getGTLTValue(value);
        this.where[key] = { $gt };
        return this;
    }
    lt(key, value) {
        const $lt = getGTLTValue(value);
        this.where[key] = { $lt };
        return this;
    }
    limit(limit) {
        this.limitResults = limit;
        if (this.limitResults > exports.MAX_API_RESULTS) {
            throw new Error('QUERY_HUGE_LIMIT');
        }
        return this;
    }
    skip(skip) {
        this.skippedResults = skip;
        return this;
    }
    find() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const startTime = Date.now();
            const queryObj = { where: this.where, limit: this.limitResults, skip: this.skippedResults };
            if (this.sortField) {
                queryObj['order'] = this.sortField;
            }
            const response = yield this.core.action(`${this.ike.actionName}.query`, queryObj, this.sessionToken, this.departmentId);
            const duration = Date.now() - startTime;
            const documents = response.results;
            this.log.info({
                object: this.ike.className,
                found: documents.length,
                keys: Object.keys(this.where).join(', '),
                duration,
            }, 'find');
            return documents;
        });
    }
    findAll() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const startTime = Date.now();
            const LIMIT = exports.MAX_API_RESULTS;
            let queryResLen = LIMIT;
            let queryObj;
            let response;
            let duration;
            let documents = [];
            let count = 0;
            while (queryResLen >= LIMIT) {
                queryObj = { where: this.where, limit: LIMIT, skip: LIMIT * count };
                if (this.sortField) {
                    queryObj['order'] = this.sortField;
                }
                response = yield this.core.action(`${this.ike.actionName}.query`, queryObj, this.sessionToken, this.departmentId);
                if (documents.length > 0) {
                    documents = documents.concat(response.results);
                }
                else {
                    documents = response.results;
                }
                queryResLen = response.results.length;
                count++;
            }
            duration = Date.now() - startTime;
            this.log.info({
                object: this.ike.className,
                found: documents.length,
                keys: Object.keys(this.where).join(', '),
                duration,
            }, 'find');
            return documents;
        });
    }
    findOne() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            this.limitResults = 1;
            const documents = yield this.find();
            return documents[0];
        });
    }
}
exports.IkeRestQuery = IkeRestQuery;
//# sourceMappingURL=query.js.map